import type {BlobLayoutStyledBlobPayload} from '@github-ui/code-view-types'
import React from 'react'

const defaultBlob: BlobLayoutStyledBlobPayload = {
  colorizedLines: null,
  rawLines: null,
  stylingDirectives: undefined,
}

const CurrentStyledBlobContext = React.createContext(defaultBlob)

export function CurrentStyledBlobProvider({
  blob,
  children,
}: React.PropsWithChildren<{blob?: BlobLayoutStyledBlobPayload}>) {
  return <CurrentStyledBlobContext value={blob ?? defaultBlob}> {children} </CurrentStyledBlobContext>
}

export function useCurrentStyledBlob() {
  return React.use(CurrentStyledBlobContext)
}
